import { FC } from "react";
import { ITooltipType } from "./interface";
import { Tooltip } from "antd";
import styles from "./ITooltip.module.scss";

const defaultInnerStyle = {
  color: "#5F7380",
  fontSize: "14px",
};

const defaultOverlayStyle = { maxWidth: "none" };

export const ITooltip: FC<ITooltipType> = ({
  title,
  placement,
  color = "white",
  overlayInnerStyle = defaultInnerStyle,
  overlayStyle = defaultOverlayStyle,
  className,

  children,
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      color={color}
      overlayStyle={overlayStyle}
      overlayInnerStyle={overlayInnerStyle}
      className={`${styles.tooltip} ${className}`}
    >
      {children}
    </Tooltip>
  );
};
